<template>
    <PBMComponent no-cancel-button :pbm-id="pbmId"/>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import PBMComponent from "@/components/Audit/PBMComponent.vue";
import SearchComponent from "@/components/SearchComponent.vue";

@Component({
    name: "PharmacyBenefitManagerPage",
    components: { SearchComponent, PBMComponent },
})
export default class PharmacyBenefitManagerPage extends Vue {

    // @Watch('$route.params', { immediate: true, deep: true })
    get pbmId(){
        if (this.$route.params.id) return parseInt(this.$route.params.id);
        return null;
    }
}
</script>
